module.exports = __webpack_public_path__ + "static/media/seed-of-healing-enhance.206aa785.png";